export const API_URL =  process.env.VUE_APP_ENV_API_URL || "https://apiman.antilaundry.ru/api";